function StatusTag({ status }) {
  return (
    <span className={`status-tag status-${status.toLowerCase()}`}>
      {status}
    </span>
  );
}

export default StatusTag;
